import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';
import {
    Card,
    CardContent,
    Grid,
    TextField,
    Button,
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Divider,
} from "@mui/material";

const colors = {
    darkGreen: '#06362D',
    calPolyGreen: '#155332',
    vanilla: '#DEE2B1',
    gold: '#FFD500',
    goldenrod: '#D1A505'
};

const animationStyles = `
  @keyframes continuousBorderPulse {
    0% { border-color: #155332; box-shadow: 0 8px 30px rgba(0,0,0,0.5); }
    50% { border-color: rgba(209, 165, 5, 0.4); box-shadow: 0 0 25px rgba(255, 213, 0, 0.1), inset 0 0 10px rgba(0,0,0,0.5); }
    100% { border-color: #155332; box-shadow: 0 8px 30px rgba(0,0,0,0.5); }
  }

  @keyframes continuousBreathe {
    0%, 100% { transform: scale(1); text-shadow: 0 4px 10px rgba(0,0,0,0.6); }
    50% { transform: scale(1.01); text-shadow: 0 6px 15px rgba(255, 213, 0, 0.2); }
  }

  @keyframes iconPulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); color: #FFD500; }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(15px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .anim-border-glow {
    animation: continuousBorderPulse 5s ease-in-out infinite;
  }
  .anim-breathe-text {
    animation: continuousBreathe 4s ease-in-out infinite;
  }
  .anim-icon-pulse {
    animation: iconPulse 3s ease-in-out infinite;
  }
  .page-fade-in {
    animation: fadeIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
  
  /* Custom Scrollbar */
  ::-webkit-scrollbar { width: 8px; height: 8px; }
  ::-webkit-scrollbar-track { background: rgba(0,0,0,0.3); }
  ::-webkit-scrollbar-thumb { background: #D1A505; border-radius: 4px; }
  ::-webkit-scrollbar-thumb:hover { background: #FFD500; }

  /* --- METICULOUS PRINT STYLES (Zero Left Margin / Full Width) --- */
  @media print {
    @page {
        size: A4;
        margin: 0mm;
    }

    html, body, #root {
        background: #fff !important;
        margin-left: -80px !important;
        padding: 0 !important;
        width: 1600px !important;
        color: #000 !important;
    }

    /* Hide elements not needed in print */
    .no-print, nav, header, footer, .sidebar, button, .MuiTextField-root {
        display: none !important;
    }

    /* Override dark themes globally */
    * {
        color: #000 !important;
        background: transparent !important;
        box-shadow: none !important;
        text-shadow: none !important;
        animation: none !important;
        border-color: #ccc !important;
    }

    /* Force full width and eliminate left offsetting or padding */
    .page-fade-in {
        padding: 0 !important;
        margin: 0 !important;
        max-width: 100% !important;
        width: 100% !important;
        left: 0 !important;
    }

    .invoice-print-wrapper {
        width: 100% !important;
        max-width: 100% !important;
        flex-basis: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .print-area {
        border: none !important;
        background: #fff !important;
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
    }

    /* Table styling for print */
    table {
        width: 100% !important;
        border-collapse: collapse !important;
    }
    
    th, td {
        border: 1px solid #ddd !important;
        padding: 6px 8px !important;
        color: #000 !important;
    }

    th {
        background-color: #f5f5f5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        font-weight: bold !important;
    }

    .MuiChip-root {
        border: 1px solid #000 !important;
        background: transparent !important;
        color: #000 !important;
    }

    .row {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        width: 100% !important;
    }
    .col-sm-12 {
        width: 100% !important;
        max-width: 100% !important;
        flex-basis: 100% !important;
    }
  }
`;

function Allbookingreport() {
    const [userData, setUserData] = useState(null);
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    
    // Default values set to today's date
    const [fromDate, setfromDate] = useState(moment().format('YYYY-MM-DD'));
    const [toDate, settoDate] = useState(moment().format('YYYY-MM-DD'));

    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [total, settotal] = useState(0);
    const [propertyId, setPropertyId] = useState(null);
    const [propData, setpropData] = useState({});

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: colors.calPolyGreen,
        color: colors.vanilla,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (userData) {
            fethUsers();
        }
    }, [userData]);

    useEffect(() => {
        if (propertyId && fromDate && toDate) {
            getReport();
        }
    }, [propertyId]);

    const fethUsers = async () => {
        try {
            if (userData && loadincount) {
                const docRef = doc(db, "authroles", userData.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setusername(docSnap.data().name);
                    const pid = docSnap.data().propertyId;
                    setPropertyId(pid);
                    setloadincount(false);

                    const propSnap = await getDoc(doc(db, "properties", pid));
                    if (propSnap.exists()) {
                        setpropData({ ...propSnap.data() });
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getReport = async () => {
        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }

        if (!propertyId) {
            Toast.fire({ icon: "error", title: 'Property ID missing. Please reload.' });
            return;
        }

        setloading(true);
        setbookingData([]);
        setpaymodes([]);
        setpayhistory([]);

        try {
            const startOfDay = new Date(fromDate);
            startOfDay.setHours(0, 0, 0, 0);
            
            const endOfDay = new Date(toDate);
            endOfDay.setHours(23, 59, 59, 999);

            const startStr = moment(fromDate).format('YYYY-MM-DD');
            const endStr = moment(toDate).format('YYYY-MM-DD');

            const payHistoryQuery = query(
                collection(db, "payhistory"),
                where("createdAt", ">=", Timestamp.fromDate(startOfDay)),
                where("createdAt", "<=", Timestamp.fromDate(endOfDay)),
                where("propertyId", "==", propertyId)
            );

            const reservationsQuery = query(
                collection(db, "reservations"),
                where("propertyId", "==", propertyId),
                where("checkindate", ">=", startStr),
                where("checkindate", "<=", endStr)
            );

            const [payHistorySnapshot, reservationsSnapshot, paymentModesSnapshot] = await Promise.all([
                getDocs(payHistoryQuery),
                getDocs(reservationsQuery),
                getDocs(collection(db, "paymentmodes"))
            ]);

            const paymentModesMap = {};
            paymentModesSnapshot.docs.forEach(doc => {
                paymentModesMap[doc.id] = doc.data().paymode;
            });

            const payHistoryDataPromises = payHistorySnapshot.docs.map(async (doc1) => {
                const docData = doc1.data();
                const paymode1 = paymentModesMap[docData.paymode1] || docData.paymode1 || "";
                const paymode2 = paymentModesMap[docData.paymode2] || docData.paymode2 || "";
                const date = docData.createdAt?.toDate ? docData.createdAt.toDate() : new Date();
                const formattedDate = moment(date).format('DD/MM/YYYY HH:mm:ss');

                let bookingDataObj = { rooms: [], checkinDate: null, checkoutDate: null, custName: "" };
                if (docData.bookingid) {
                    const bookingSnap = await getDoc(doc(db, "reservations", docData.bookingid));
                    if (bookingSnap.exists()) {
                        const bData = bookingSnap.data();
                        bookingDataObj = {
                            rooms: bData.rooms || [],
                            checkinDate: bData.checkindate || null,
                            checkoutDate: bData.checkoutdate || null,
                            custName: bData.customers?.custname || bData.custname || ""
                        };
                    }
                }

                return {
                    id: doc1.id,
                    data: docData,
                    paymode1,
                    paymode2,
                    createdat: formattedDate,
                    bookingData: bookingDataObj
                };
            });

            const resolvedPayHistory = await Promise.all(payHistoryDataPromises);
            setpayhistory(resolvedPayHistory);

            const paymodeTotals = {};
            resolvedPayHistory.forEach(item => {
                if (item.data.status === "Working") {
                    if (item.paymode1 && item.data.amount1) {
                        paymodeTotals[item.paymode1] = (paymodeTotals[item.paymode1] || 0) + Number(item.data.amount1);
                    }
                    if (item.paymode2 && item.data.amount2) {
                        paymodeTotals[item.paymode2] = (paymodeTotals[item.paymode2] || 0) + Number(item.data.amount2);
                    }
                }
            });

            const paymentDataFormatted = Object.keys(paymentModesMap).map(id => {
                const name = paymentModesMap[id];
                return {
                    id,
                    paymode: name,
                    totalamount: (paymodeTotals[name] || 0).toFixed(2)
                };
            });
            setpaymodes(paymentDataFormatted);

            const calculatedTotal = Object.values(paymodeTotals).reduce((acc, val) => acc + val, 0);
            settotal(calculatedTotal.toFixed(0));

            const combinedDataPromises = reservationsSnapshot.docs.map(async (resDoc) => {
                const reservation = { id: resDoc.id, ...resDoc.data() };

                let usernameVal = "Unknown User";
                if (reservation.uid) {
                    const userSnap = await getDoc(doc(db, "authroles", reservation.uid));
                    if (userSnap.exists()) {
                        usernameVal = userSnap.data().name || "Unnamed User";
                    }
                }

                const roomamount = Number(reservation.rooamount || reservation.roomamount || 0);
                const noOfDays = Number(reservation.noofdays || 1);
                const serviceamount = Number(reservation.serviceamount || 0) / (noOfDays || 1);

                const ordersQuery = query(
                    collection(db, 'orders'),
                    where('bookingId', '==', reservation.id),
                    where('propertyId', '==', propertyId)
                );
                const ordersSnap = await getDocs(ordersQuery);
                let foodTotal = 0;
                ordersSnap.forEach((ordDoc) => {
                    const ordData = ordDoc.data();
                    foodTotal += Number(ordData.totalamount || 0);
                });

                const matchingPayments = resolvedPayHistory.filter(p => p.data.bookingid === reservation.id);
                const paidAmount = matchingPayments.reduce((sum, p) => sum + Number(p.data.amount1 || 0) + Number(p.data.amount2 || 0), 0);
                const totalAmountCalc = roomamount + serviceamount + foodTotal;
                const grandTotal = totalAmountCalc * noOfDays;
                const remaining = grandTotal - paidAmount;

                return {
                    ...reservation,
                    booking: reservation,
                    username: usernameVal,
                    serviceamount: serviceamount.toFixed(0),
                    roomamount: roomamount.toFixed(0),
                    foodamount: foodTotal.toFixed(0),
                    totalamount: totalAmountCalc.toFixed(0),
                    alltoal: grandTotal.toFixed(0),
                    paidamount: paidAmount.toFixed(0),
                    pending: remaining.toFixed(0),
                    todayDays: noOfDays,
                    paymentHistory: matchingPayments
                };
            });

            const finalBookingData = await Promise.all(combinedDataPromises);
            setbookingData(finalBookingData);

        } catch (error) {
            console.error("Error generating report:", error);
            Toast.fire({ icon: "error", title: "Failed to generate report" });
        } finally {
            setloading(false);
        }
    };

    const handlePrint = () => {
        window.print();
    };

    const handleFromDate = (e) => {
        setfromDate(e.target.value);
    };

    const handleToDate = (e) => {
        settoDate(e.target.value);
    };

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: colors.darkGreen, color: colors.vanilla, p: { xs: 1, md: 2 } }} className="page-fade-in">
            <style>{animationStyles}</style>
            <Box component="main" sx={{ flexGrow: 1, width: "100%", margin: 0, padding: 0 }} className="invoice-print-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid p-0" style={{ width: '100%', margin: 0 }}>
                        <Typography variant="h5" fontWeight={800} mb={3} sx={{ color: colors.vanilla }} className="no-print">
                            All Booking Report
                        </Typography>

                        <div className="row" style={{ width: '100%', margin: 0 }}>
                            <div className="col-md-12 p-0" style={{ width: '100%' }}>
                                <Card sx={{ borderRadius: 3, border: `1px solid ${colors.goldenrod}`, bgcolor: colors.calPolyGreen, color: colors.vanilla, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.3)", mb: 4 }} className="no-print anim-border-glow">
                                    <CardContent sx={{ p: 3 }}>
                                        <div className="container-fluid p-0">
                                            <div className="row align-items-center">
                                                <div className="col-sm-4 mb-3 mb-sm-0">
                                                    <TextField
                                                        label="From Date"
                                                        type="date"
                                                        value={fromDate}
                                                        onChange={handleFromDate}
                                                        fullWidth
                                                        size='small'
                                                        InputLabelProps={{ shrink: true, style: { color: colors.vanilla } }}
                                                        InputProps={{ style: { color: colors.vanilla } }}
                                                        sx={{ 
                                                            "& .MuiOutlinedInput-root": { 
                                                                borderRadius: "8px",
                                                                backgroundColor: colors.darkGreen,
                                                                "& fieldset": { borderColor: colors.goldenrod },
                                                                "&:hover fieldset": { borderColor: colors.gold },
                                                                "&.Mui-focused fieldset": { borderColor: colors.gold }
                                                            } 
                                                        }}
                                                    />
                                                </div>

                                                <div className="col-sm-4 mb-3 mb-sm-0">
                                                    <TextField
                                                        label="To Date"
                                                        type="date"
                                                        value={toDate}
                                                        onChange={handleToDate}
                                                        fullWidth
                                                        size='small'
                                                        InputLabelProps={{ shrink: true, style: { color: colors.vanilla } }}
                                                        InputProps={{ style: { color: colors.vanilla } }}
                                                        sx={{ 
                                                            "& .MuiOutlinedInput-root": { 
                                                                borderRadius: "8px",
                                                                backgroundColor: colors.darkGreen,
                                                                "& fieldset": { borderColor: colors.goldenrod },
                                                                "&:hover fieldset": { borderColor: colors.gold },
                                                                "&.Mui-focused fieldset": { borderColor: colors.gold }
                                                            } 
                                                        }}
                                                    />
                                                </div>

                                                <div className="col-sm-4">
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        disabled={loading}
                                                        sx={{ 
                                                            bgcolor: colors.goldenrod, 
                                                            color: colors.darkGreen, 
                                                            fontWeight: 700, 
                                                            textTransform: "none", 
                                                            borderRadius: "8px",
                                                            height: "40px",
                                                            '&:hover': { bgcolor: colors.gold } 
                                                        }}
                                                        onClick={getReport}
                                                    >
                                                        {loading ? "Loading..." : "Get Report"}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>

                                <Card className="print-area anim-border-glow" sx={{ borderRadius: 3, border: `1px solid ${colors.goldenrod}`, bgcolor: colors.calPolyGreen, color: colors.vanilla, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.3)", width: '100%', margin: 0 }}>
                                    <CardContent sx={{ p: 3, width: '100%', boxSizing: 'border-box' }}>
                                        <Box p={1} mb={3}>
                                            <div className="container-fluid p-0">
                                                <div className="row align-items-center text-center">
                                                    <div className="col-sm-12">
                                                        <Typography variant="h5" fontWeight="bold" sx={{ textTransform: "uppercase", color: colors.gold, mb: 1 }} className="anim-breathe-text">
                                                            {propData.hotelname || "Hotel Report"}
                                                        </Typography>
                                                        <Typography variant="subtitle2" sx={{ color: colors.vanilla }}>
                                                            GSTIN No - {propData.gstno || "—"}
                                                        </Typography>
                                                        <Typography sx={{ color: colors.vanilla, opacity: 0.9, mt: 0.5 }}>
                                                            {propData.address} {propData.city} {propData.state} {propData.pincode}
                                                            <br />
                                                            Phone: +91 {propData.mobile} | Email: {propData.email}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                        </Box>

                                        {/* BOOKING REPORT */}
                                        <Typography variant="subtitle1" sx={{ bgcolor: colors.darkGreen, color: colors.gold, p: 1.5, fontWeight: 700, borderRadius: "8px 8px 0 0", borderTop: `1px solid ${colors.goldenrod}` }}>
                                            Booking Report
                                        </Typography>

                                        <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "0 0 8px 8px", border: `1px solid ${colors.goldenrod}`, backgroundColor: "transparent", mb: 4, width: '100%' }}>
                                            <Table size="small" sx={{ width: '100%' }}>
                                                <TableHead sx={{ bgcolor: colors.darkGreen }}>
                                                    <TableRow>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Sr No</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Customer Name</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Checkin Date</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Checkout Date</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Days</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Rooms</TableCell>
                                                        <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Amount</TableCell>
                                                        <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Extra</TableCell>
                                                        <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Food</TableCell>
                                                        <TableCell align="right" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Total</TableCell>
                                                        <TableCell align="center" sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Payments</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Username</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {bookingData.length === 0 && (
                                                        <TableRow>
                                                            <TableCell colSpan={12} align="center" sx={{ py: 4, color: colors.vanilla, opacity: 0.7 }}>
                                                                No booking records found for this date range
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    {bookingData.map((item, index) => (
                                                        <TableRow key={index} hover sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' } }}>
                                                            <TableCell sx={{ color: colors.vanilla }}>{index + 1}</TableCell>
                                                            <TableCell sx={{ color: colors.gold, fontWeight: 600, textTransform: "capitalize" }}>
                                                                {item.customers?.custname || item.custname || "—"}
                                                            </TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.checkindate ? moment(item.checkindate).format('DD/MM/YYYY') : '—'} {item.checkintime}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.checkoutdate ? moment(item.checkoutdate).format('DD/MM/YYYY') : '—'} {item.checkouttime}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.noofdays}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>
                                                                {item.rooms?.map((room, idx) => (
                                                                    <span key={idx}>{room.roomno}<br /></span>
                                                                ))}
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ color: colors.vanilla }}>{item.roomamount}</TableCell>
                                                            <TableCell align="right" sx={{ color: colors.vanilla }}>{item.serviceamount}</TableCell>
                                                            <TableCell align="right" sx={{ color: colors.vanilla }}>{item.foodamount}</TableCell>
                                                            <TableCell align="right" sx={{ color: colors.gold, fontWeight: 700 }}>{item.alltoal}</TableCell>
                                                            <TableCell align="center">
                                                                {item.paymentHistory.length > 0 ? (
                                                                    item.paymentHistory.map((ph, pIdx) => (
                                                                        <React.Fragment key={pIdx}>
                                                                            {Number(ph.data.amount1) > 0 && <Typography variant="caption" display="block"><b>{ph.paymode1}: {ph.data.amount1}</b></Typography>}
                                                                            {Number(ph.data.amount2) > 0 && <Typography variant="caption" display="block"><b>{ph.paymode2}: {ph.data.amount2}</b></Typography>}
                                                                        </React.Fragment>
                                                                    ))
                                                                ) : (
                                                                    <b style={{ color: "#f87171" }}>Pending</b>
                                                                )}
                                                            </TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.username}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        {/* COLLECTION REPORT */}
                                        <Typography variant="subtitle1" sx={{ bgcolor: colors.darkGreen, color: colors.gold, p: 1.5, fontWeight: 700, borderRadius: "8px 8px 0 0", borderTop: `1px solid ${colors.goldenrod}` }}>
                                            Collection Report
                                        </Typography>

                                        <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "0 0 8px 8px", border: `1px solid ${colors.goldenrod}`, backgroundColor: "transparent", mb: 3, width: '100%' }}>
                                            <Table size="small" sx={{ width: '100%' }}>
                                                <TableHead sx={{ bgcolor: colors.darkGreen }}>
                                                    <TableRow>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Custname</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Room</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Checkin</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Checkout</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Paymode1</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Amount1</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Paymode2</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Amount2</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Datetime</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {payhistory.length === 0 && (
                                                        <TableRow>
                                                            <TableCell colSpan={9} align="center" sx={{ py: 4, color: colors.vanilla, opacity: 0.7 }}>
                                                                No collection records found for this date range
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    {payhistory.map((item, index) => (
                                                        <TableRow key={index} hover>
                                                            <TableCell sx={{ color: colors.gold, fontWeight: 600 }}>{item.bookingData.custName || "—"}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>
                                                                {item.bookingData.rooms?.map((r, rIdx) => <span key={rIdx}>{r.roomno}<br /></span>)}
                                                            </TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.bookingData.checkinDate ? moment(item.bookingData.checkinDate).format('DD/MM/YYYY') : '—'}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.bookingData.checkoutDate ? moment(item.bookingData.checkoutDate).format('DD/MM/YYYY') : '—'}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.paymode1}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.data.amount1 || 0}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.paymode2}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.data.amount2 || 0}</TableCell>
                                                            <TableCell sx={{ color: colors.vanilla }}>{item.createdat}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        {/* TOTAL COLLECTION */}
                                        <Paper elevation={0} sx={{ mt: 3, p: 2, textAlign: "center", bgcolor: colors.darkGreen, border: `1px solid ${colors.goldenrod}`, borderRadius: 2, width: '100%', boxSizing: 'border-box' }}>
                                            <Typography variant="h6" fontWeight={700} sx={{ color: colors.gold }}>
                                                Total Collection: Rs. {total} /-
                                            </Typography>
                                        </Paper>
                                    </CardContent>
                                </Card>

                                <div className="text-center mt-3 no-print">
                                    <Button 
                                        variant="contained" 
                                        onClick={handlePrint}
                                        sx={{ 
                                            bgcolor: colors.goldenrod, 
                                            color: colors.darkGreen, 
                                            fontWeight: 700, 
                                            textTransform: "none", 
                                            borderRadius: "8px",
                                            px: 4,
                                            py: 1.2,
                                            '&:hover': { bgcolor: colors.gold } 
                                        }}
                                    >
                                        Print Report
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Box>
        </Box>
    );
}

export default Allbookingreport;